export interface StripeConnectedProject {
  projectId: string;
  projectName: string;
  projectType?: string | null;
  modes: ("test" | "live")[];
  envMode: "test" | "live" | null;
  chargesEnabled: boolean | null;
  detailsSubmitted: boolean | null;
  connectedAt: string | null;
}

// The connectors API sends these under metadata, which is untyped, so anything malformed is dropped rather than rendered.
export const readConnectedProjects = (metadata: Record<string, unknown> | undefined): StripeConnectedProject[] => {
  const raw = metadata?.connectedProjects;
  if (!Array.isArray(raw)) return [];
  return raw.filter(
    (p): p is StripeConnectedProject =>
      Boolean(p) && typeof p.projectId === "string" && typeof p.projectName === "string" && Array.isArray(p.modes),
  );
};

type PaymentState = { label: string; ready: boolean };

// Stripe can be connected before the account can take payments; saying so up front avoids a "connected but checkout fails" surprise.
export const paymentStateFor = (project: StripeConnectedProject): PaymentState => {
  if (project.chargesEnabled === true) return { label: "Payments ready", ready: true };
  if (project.chargesEnabled === false) return { label: "Finish Stripe setup", ready: false };
  return { label: "Connected", ready: true };
};
